module.exports = __webpack_public_path__ + "img/favicon.c19923d0.ico";